<template>
  <div class="help-index">
    <div class="help-text">
      <div class="help-title">中国中医古籍数字资源库-使用说明</div>
      <div class="help-subtitle">系统架构</div>
      <div class="help-content">
        本数据库为网络版，通过浏览器在线使用。系统采用B/S体系结构，使用自主研发的服务器。如果你的电脑上已经安装了其他的Web服务器软件，如微软的IIS，并且已经启动该服务器，建议先停掉该Web服务，然后启动本系统，否则本系统可能不能正常运行。
      </div>
      <div class="help-subtitle">所需配置</div>
      <div class="help-table">
        <div class="help-line">
          <div class="help-cell">CPU</div>
          <div class="help-cell-content">PIII450以上</div>
          <div class="help-cell">内存</div>
          <div class="help-cell-content">1G 以上</div>
        </div>
        <div class="help-line">
            <div class="help-cell">光驱</div>
            <div class="help-cell-content">24X以上</div>
            <div class="help-cell">显卡</div>
            <div class="help-cell-content">16位色以上</div>
        </div>
        <div class="help-line">
            <div class="help-cell">分辨率</div>
            <div class="help-cell-content">推荐1024×768</div>
            <div class="help-cell">硬盘</div>
            <div class="help-cell-content">1G以上</div>
        </div>
        <div class="help-line">
            <div class="help-cell">浏览器</div>
            <div class="help-cell-content">IE8.0以上</div>
            <div class="help-cell">操作系统</div>
            <div class="help-cell-content">WINDOWS 2000以上</div>
        </div>
      </div>
      <div class="help-subtitle">使用说明</div>
      <div class="help-content">
        数据库可实现古籍的分类浏览阅读、多途径内容检索、原图保存下载等功能。
      </div>
      <div class="help-content">
        <b>原图阅览:</b>可对古籍原图的浏览、翻页、缩放、图文切换。
        <br />
        <b>分类浏览:</b>可按古文分类查找、浏览古籍。
        <br />
        <b>多途径检索：</b>
        <br />
        <span class="inner-text">
          ——书目检索：按书名、作者、内容提要等内容进行快速检索。
          <br />
          ——关键词检索：基于原图标注信息检索古籍全文内容，支持多个关键词检索。
          <br />
          ——高级检索：书目信息及关键词的匹配、逻辑检索（支持检索项的多重“与”、“或”、“非”组合检索。多个检索项之间输入“*”表示“与”，“|”表示“或”，“!”表示“非”）。
          <br />
          ——后控检索：基于专业词表的同义词、上位词、下位词、关联词优化检索，输入关键词后，点击“后控词”可弹出可选的相关检索词。
          <br />
          ——二次检索：可在检索结果基础上进行二次检索。
          <br />
          ——书内检索：可对正在阅览的书籍进行本书内的检索。
        </span>
        <br />
        <b>保存下载：</b>可对所阅览古籍原图的下载和保存。
      </div>
      <div class="help-subtitle">联系我们</div>
      <div class="help-content">
        <b>单位：</b>中国中医科学院中医药信息研究所 特藏资源研发部
        <br />
        <b>地址：</b>北京市东城区东直门内南小街16号
        <br />
        <b>邮编：</b>100700
        <br />
        <b>电话：</b>010-64089611/64089628
        <br />
        <b>E-mail：</b>tcmbase126.com
        <br />
        <b>QQ：</b>1135616138
        <br />
        <b>技术支持：</b>点通数据有限公司
      </div>
    </div>
    <div class="help-footer">
      <div class="help-footer-inner">
        <div class="footer-left">
          <div class="footer-text-line">
            地址:北京市东城区东直门内南小街16号 邮编:100700
            <br />
            电话:8610-64089611Email:tcmbase@126.com
          </div>
          <div class="footer-text-line-below">
            ©2017 中国中医科学院中医药信息研究所版权所有 京ICP备********号
          </div>
        </div>
        <div class="footer-right">
          <img
            :src="require('@/assets/images/icons/qr-code.png')"
            class="qr-code"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpIndex',
  data () {
    return {}
  }
}
</script>

<style scoped>
.help-index {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 800px; */
}

.help-text {
  width: 1200px;
  margin: 0 auto;
  /* height: 700px; */
  margin-bottom: 20px;
  background-color: #fff;
  padding: 30px;
  /* overflow-y: scroll; */
}

/* .help-text::-webkit-scrollbar {
  width: 0;
} */

.help-title {
  font-family: mysong;
  font-weight: bold;
  font-size: 33px;
  color: #634c37;
}

.help-subtitle {
  font-size: 22px;
  font-weight: bold;
  color: #634c37;
  text-align: left;
  margin-top: 20px;
}

.help-subtitle::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 18px;
  background-color: #9e5c1d;
  margin-right: 10px;
}

.help-content {
  font-size: 16px;
  color: #634c37;
  line-height: 36px;
  text-align: left;
  width: 1122px;
  margin: 0 auto;
  margin-top: 20px;
}

.inner-text {
  display: inline-block;
  margin-left: 40px;
}

.help-footer {
  width: 100%;
  height: 132px;
  background-color: #eddfce;
}

.help-footer-inner {
  width: 800px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-text-line {
  font-size: 16px;
  color: #634c37;
  line-height: 30px;
  text-align: left;
}

.footer-text-line-below {
  font-size: 16px;
  font-weight: bold;
  color: #634c37;
  line-height: 30px;
  text-align: left;
  margin-top: 20px;
}

.qr-code {
  width: 107px;
  height: 107px;
}

.help-table {
  width: 100%;
  margin-top: 20px;
  margin-left: 60px;
}

.help-line {
  display: grid;
  grid-template-columns: 1.2fr 2fr 1.2fr 2fr;
  grid-gap: 20px;
  width: 645px;
  border: 1px solid #634C37;
  border-top: 0;
}

.help-table .help-line:first-child {
  border-top: 1px solid #634C37;
}

.help-line .help-cell,
.help-line .help-cell-content {
    display: block;
    line-height: 48px;
    color: #634C37;
}

.help-line .help-cell-content {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/views/help/index.vue